import React, {Component} from "react";
import './baby-teething.css';
// import { fetchInitialData3 } from "../../fetchData";
// import Service from '../../service/Service';
import * as teethActions from './TeethingActions';

export default function ChildTeethInfo({ChildTeethData, eleRef}) {
    
    // console.log("ChildTeethData",ChildTeethData);
    return(
        <div>
            <div className="tooth-erptn-inner">
                <span className="age-count baby-age M13_42">Age:<br/>
                {eleRef.state.isLogin ? eleRef.currentM : 0} Months</span>
                <span className="age-count baby-teeth-count M13_42">Teeth:<br/>
                <span className="teeth-count">{eleRef.state.teethCount ? eleRef.state.teethCount : 0}</span>
                </span>
                <div className="baby-jaw">
                    <img src={require("../images/baby-teeth/jaw-bg.svg")} />
                    <span className="lower-jaw M15_white">Lower Jaw</span>
                    <span className="upper-jaw M15_white">Upper Jaw</span>
                    {ChildTeethData && ChildTeethData.map(babyteeth => 
                    <div key={babyteeth.toothId} className={"baby-teeth teeth-" + babyteeth.toothId + babyteeth.toothNumber} id={babyteeth.toothId}>
                    {
                        babyteeth.isHighLited==1 ? 
                        <div className="white-teeth" id={"white_" + babyteeth.toothId} onClick={(e)=>teethActions.addDetails(babyteeth.toothId, eleRef)}>
                            <span className="teethnum M13_42">{babyteeth.toothNumber}</span>
                        {
                            ((babyteeth.toothNumber == 9) || (babyteeth.toothNumber == 10)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-1.svg")}/> : ((babyteeth.toothNumber == 6) || (babyteeth.toothNumber == 5)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-2.svg")}/> : ((babyteeth.toothNumber == 8) || (babyteeth.toothNumber == 7)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-3.svg")}/> : ((babyteeth.toothNumber == 4) || (babyteeth.toothNumber == 3)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-4.svg")}/> : ((babyteeth.toothNumber == 1) || (babyteeth.toothNumber == 2)) ? 
                            <img src={require("../images/baby-teeth/white-teeth-5.svg")}/> : null
                        }
                        </div> : 
                        <div className="pink-teeth" id={"pink_" + babyteeth.toothId} onClick={(e)=>teethActions.addDetails(babyteeth.toothId, eleRef)}>
                            <span className="teethnum M13_white">{babyteeth.toothNumber}</span>
                        {
                            ((babyteeth.toothNumber == 9) || (babyteeth.toothNumber == 10)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-1.svg")}/> : ((babyteeth.toothNumber == 6) || (babyteeth.toothNumber == 5)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-2.svg")}/> : ((babyteeth.toothNumber == 8) || (babyteeth.toothNumber == 7)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-3.svg")}/> : ((babyteeth.toothNumber == 4) || (babyteeth.toothNumber == 3)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-4.svg")}/> : ((babyteeth.toothNumber == 1) || (babyteeth.toothNumber == 2)) ? 
                            <img src={require("../images/baby-teeth/pink-teeth-5.svg")}/> : null
                        }
                        </div>
                    }
                        <hr className={"myline info-line_" + babyteeth.toothId} />
                        <input type="hidden" value={babyteeth.startMonth} className="childstartmonth" />
                        <input type="hidden" value={babyteeth.endMonth} className="childendmonth" />
                    </div>
                    )}
                    <div className="tooth-info">
                        <div>{eleRef.state.toothName}</div>
                        <div>{eleRef.state.toothMonth}</div>
                        <div>{eleRef.state.userDate}</div>
                    </div>
                </div>
                <span className="R M15_75">R</span>
                <span className="L M15_75">L</span>
            </div>
            <div className="baby-size-weeks">
                <div className="weeks-section" onScroll={() => teethActions.monthbarScroll(eleRef)}>
                    <ul className="week-bar monthbar">
                        {eleRef.displayMonthslider()}
                    </ul>
                </div>
                <span className="week-next" data-icon-font="h" onClick={() => {eleRef.slideRight(eleRef.state.clickwedWeek)}}></span>
                <span className="week-prev" data-icon-font="g" onClick={() => {eleRef.slideLeft(eleRef.state.clickwedWeek)}}></span>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// src/shared/tools/baby-teething/ChildTeethInfo.js